import PropTypes from "prop-types";
import React from "react";

import Nav from "./nav";
import Logo from "../components/logo";

const Header = () => {
  return (
    <header>
      <div className="header-logo">
        <Logo />
      </div>
      <Nav />
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

export default Header;
